import React, { useState, useEffect, useCallback } from 'react';
import './ListUsers.css';
import ConfirmationModal from '../../Notification/ConfirmationModal'; // Az új modal importálása
import Notification from '../../Notification/Notification'; // Az notification importálása
import CreateUsers from '../CreateUsers/CreateUsers.js'; // Hozzáadjuk
import UserFilter from '../UserFilter/UserFilter';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const apiUrl = process.env.REACT_APP_API_URL;

function ListUsers() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [token] = useState(localStorage.getItem('token') || '');
  const [editUser, setEditUser] = useState(null); // Szerkesztett kategória állapota
  const [isEditing, setIsEditing] = useState(false); // Szerkesztési mód állapota
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [userLevel, setUserLevel] = useState(0);


  // Listázás
  const fetchUsers = useCallback(() => {
    const userId = localStorage.getItem('id');
    const level = parseInt(localStorage.getItem('level'));
    setUserLevel(level);
    const url = level < 3
      ? `${apiUrl}/users/${userId}` // Ha a level < 3, az URL-be az id kerül
      : `${apiUrl}/users`; // Egyébként az alapértelmezett URL

    fetch(url, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(response.body)
      })
      .then((data) => {
        setUsers(data);
        setFilteredUsers(data);
      })
      .catch((error) => {
        setNotification({ message: 'Hiba történt a felhasználó lekérdezése során.', type: 'error' });
        console.error('Error fetching users:', error)
      });
  }, [token]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // Kategória szerkesztésének megkezdése
  const handleEdit = (userId) => {
    const userToEdit = users.find(user => user.id === userId);
    setEditUser(userToEdit);
    setIsEditing(true);
  };

  // Mentés utáni visszatérés
  const handleSaveSuccess = () => {
    setIsEditing(false);
    fetchUsers(); // Frissítjük a kategóriákat
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleDeleteUser = async () => {
    const response = await fetch(`${apiUrl}/users/${selectedUserId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (response.ok) {
      setNotification({ message: 'A felhasználó sikeresen törölve.', type: 'success' });
      fetchUsers(); // Frissítjük a listát a törlés után
      setShowModal(false); // Modal bezárása
    } else {
      setNotification({ message: 'Hiba történt a felhasználó törlése során.', type: 'error' });
    }
  };

  const openModal = (userId) => {
    setSelectedUserId(userId);
    setShowModal(true); // Modal megjelenítése
  };

  const closeModal = () => {
    setShowModal(false); // Modal bezárása
  };

  return (
    <div className="list-users">
      {isEditing ? (
        <CreateUsers
          selectedUser={editUser}
          onSaveSuccess={handleSaveSuccess}
          onCancel={handleCancelEdit}
        />
      ) : (
        <>
          <h2>Felhasználók Listája</h2>
          <Collapse className="mb-3">
            <Panel header="Felhasználó szűrő" key="filter">
              <UserFilter
                onFilter={(filters) => {
                  const newData = users.filter(item => {
                    const matchesName = item.name.includes(filters.name);
                    return matchesName;
                  });
                  setFilteredUsers(newData);
                }}

              />
            </Panel>
          </Collapse>

          <table className="users-table">
            <thead>
              <tr>
                <th>Azonosító</th>
                <th>Felhasználó Neve</th>
                <th>Felhasználó teljes neve</th>
                <th>Szint</th>
                <th>Műveletek</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map(user => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.name}</td>
                  <td>{user.fullname}</td>

                  <td>{user.level}</td>

                  <td>
                    <button onClick={() => handleEdit(user.id)}>Szerkesztés</button>
                    {userLevel > 2 && <button
                      onClick={() => openModal(user.id)}
                      style={{ marginLeft: '10px', backgroundColor: '#f44336', color: 'white' }}
                    >
                      Törlés
                    </button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {/* Modal megjelenítése */}
      <ConfirmationModal
        show={showModal}
        message="Biztosan törölni szeretnéd ezt a felhasználót?"
        onConfirm={handleDeleteUser}
        onCancel={closeModal}
      />

      {/* Notification komponens */}
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
}

export default ListUsers;
